"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.map.js");

require("core-js/modules/es6.array.slice.js");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./BackgroundSelector.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackgroundSelector = function BackgroundSelector(_ref) {
  var _ref$backgroundsArray = _ref.backgroundsArray,
      backgroundsArray = _ref$backgroundsArray === void 0 ? [] : _ref$backgroundsArray,
      setBackgroundId = _ref.setBackgroundId,
      backgroundId = _ref.backgroundId;

  var backgroundTileClasses = function backgroundTileClasses(tileId) {
    return (0, _classnames.default)('background-tile', {
      active: (backgroundId === null || backgroundId === void 0 ? void 0 : backgroundId.active) === tileId || !backgroundId
    });
  };

  var handleSelect = function handleSelect(id) {
    var idSelected = id === (backgroundId === null || backgroundId === void 0 ? void 0 : backgroundId.active) ? undefined : id;
    setBackgroundId({
      active: idSelected,
      previous: undefined
    });
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "modal2020-background-selector"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: backgroundTileClasses(),
    onClick: function onClick() {
      return handleSelect();
    }
  }), backgroundsArray.slice(0, 10).map(function (_ref2) {
    var id = _ref2.id,
        url = _ref2.url;
    return /*#__PURE__*/_react.default.createElement("button", {
      key: "background-num-".concat(id),
      style: {
        backgroundImage: "url('".concat(url, "')")
      },
      className: backgroundTileClasses(id),
      onClick: function onClick() {
        return handleSelect(id);
      }
    });
  }));
};

var array = _propTypes.default.array,
    func = _propTypes.default.func,
    shape = _propTypes.default.shape,
    number = _propTypes.default.number;
BackgroundSelector.propTypes = {
  backgroundsArray: array,
  setBackgroundId: func.isRequired,
  backgroundId: shape({
    active: number,
    previous: number
  })
};
var _default = BackgroundSelector;
exports.default = _default;